<template>
  <div class="inspectionRecords">
    <el-row>
      <el-col class="form">
        <el-form :model="formData" label-width="80px">
          <!-- <el-form-item label="检测机构">
            <patientTree @input="input"></patientTree>
          </el-form-item>
          <el-form-item label="风险等级">
            <el-select v-model="formData.risk" placeholder="全部">
              <el-option label="全部" :value="null"></el-option>
              <el-option label="绿色" value="1"></el-option>
              <el-option label="黄色" value="2"></el-option>
              <el-option label="红色" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="血压危险">
            <el-select v-model="formData.critical" placeholder="全部">
              <el-option label="全部" :value="null"></el-option>
              <el-option label="危急值" value="1"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="测量时间">
            <el-date-picker v-model="valueData" type="daterange" align="right" unlink-panels range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="margin-left: 40px" @click="getBloodPressureList">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col>
        <el-table class="inspectionTable" :row-class-name="tableRowClassName" v-loading="listLoading" :data="manageList"
          fit>
          <el-table-column width="150px" align="center" label="测量时间">
            <template slot-scope="scope">
              <span>{{ scope.row.time }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="姓名">
            <template slot-scope="scope">
              <span>{{ scope.row.measurerName }}</span>
            </template>
          </el-table-column>

          <el-table-column width="170px" align="center" label="身份证号">
            <template slot-scope="scope">
              <span>{{ scope.row.measurerIdentityCard }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="血压值">
            <template slot-scope="scope">
              <span>{{ scope.row.systolicPressure }}/{{ scope.row.diastolicPressure }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="测量机构">
            <template slot-scope="scope">
              <span>{{ scope.row.dataSources }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col>
        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.pageNum" :limit.sync="listQuery.pageSize"
          @pagination="turnToPage" />
      </el-col>
    </el-row>

  </div>
</template>

<script>
import { getBloodPressureList, turnToBloodPressureList } from "@/api/health/Patients";
import Pagination from "@/components/Pagination";
// import patientTree from '@/views/cloudhealth/patient/npListComponents/selectTree';
import patientTree from '@/components/selectTree';

export default {
  components: { Pagination, patientTree },
  props: {
    pInfo: null,
  },
  data() {
    return {
      formData: {
        // risk: null,
        // critical: null,
        measurerName: null,
        idcard: null,
        // managerHospitals: [],
        startTime: null,
        endTime: null
      },
      data: [],
      valueData: null,
      manageList: [],
      listLoading: false,
      total: 0,
      listQuery: {
        pageNum: 1,
        pageSize: 10
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime());
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    }
  },
  created() {
    this.getBloodPressureList();
  },
  methods: {
    getBloodPressureList() {
      if (this.valueData != null) {
        this.formData.startTime = this.valueData[0] ? this.getParseDate(this.valueData[0], 1) : null;
        this.formData.endTime = this.valueData[1] ? this.getParseDate(this.valueData[1], 2) : null;
      } else {
        this.formData.startTime = null;
        this.formData.endTime = null;
      }
      let params = Object.assign({}, this.listQuery, this.formData)
      params.idcard = this.pInfo.idcard;
      params.measurerName = this.pInfo.name;

      this.listLoading = true;
      getBloodPressureList(params).then((res) => {
        this.listLoading = false;
        if (res.msg == "success") {
          this.manageList = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    // 日期格式转化
    getParseDate(time, type) {
      if (type == 1) {
        var newTime = new Date(time);
      } else if (type == 2) {
        var newTime = new Date(((new Date(time) / 1000) + 86400) * 1000);
      }
      // 获取完整的年份(4位)
      var year = newTime.getFullYear();
      // 获取月份(0-11,0代表1月)
      var month = newTime.getMonth() + 1;
      // 获取日期(1-31)
      var date = newTime.getDate();

      return year + "-" + (month < 10 ? '0' + month : month) + "-" + (date < 10 ? '0' + date : date);
    },
    // 获取机构数组
    input(value) {
      // this.formData.managerHospitals = value;
    },
    // 导航跳转查询列表页
    turnToPage() {
      // if (this.formData.bloodsugarLe > this.formData.bloodsugarGe) {
      //   this.$message({
      //     message: "血糖范围左侧值必须小于右侧值，请重选后再次查询！",
      //     type: "error"
      //   })
      //   return;
      // }
      if (this.valueData != null) {
        this.formData.startTime = this.valueData[0] ? this.getParseDate(this.valueData[0], 1) : null;
        this.formData.endTime = this.valueData[1] ? this.getParseDate(this.valueData[1], 2) : null;
      } else {
        this.formData.startTime = null;
        this.formData.endTime = null;
      }
      let params = Object.assign({}, this.listQuery, this.formData)
      params.idcard = this.pInfo.idcard;
      params.measurerName = this.pInfo.name;

      this.listLoading = true;
      turnToBloodPressureList(params).then((res) => {
        this.listLoading = false;
        if (res.msg == "success") {
          this.manageList = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    // 修改条纹颜色
    tableRowClassName({ row, rowIndex }) {
      if (row.codiagStatus == 0) {
        if (row.risk == 3) {
          return 'light-row'
        } else if (row.risk == 2) {
          return 'aterrimus-row'
        } else if (row.risk == 1) {
          return 'green-row'
        }
      } else {
        return;
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.inspectionTable {
  ::v-deep {
    .light-row {
      background: rgba(255, 0, 0, 0.579) !important;
    }

    .aterrimus-row {
      //黄
      background: yellow !important;
    }

    .green-row {
      background: greenyellow;
    }

    .el-table__cell {
      height: 50px !important;
    }
  }

}


.form ::v-deep {
  .el-form-item {
    display: inline-flex;
  }

  .el-input--medium .el-input__inner {
    width: 209px !important;
  }

  .el-form-item__content {
    margin-left: 10px !important;
  }
}
</style>